import { Plugin } from 'prosemirror-state';
import { ContentNodeWithPos } from 'prosemirror-utils';

import { TFunction } from '@lyearn/i18n';
import { AddMenuText, NormalText } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock, setPlaceholder } from '../../../utils/menus';
import { NODE_NAME } from '../consts';

const NAME_MAPPING: (t: TFunction) => { [key: string]: string } = (t) => ({
  list_item: t('Lygo:List'),
  table_header: ' ',
  table_cell: ' ',
  toggle_block_heading: t('Lygo:Toggle'),
  check_list_item: t('Common:AddItem'),
});

function plugins({ t }: EditorOptions): Plugin[] {
  return [
    new Plugin({
      view: (editorView) => {
        setPlaceholder(editorView, NODE_NAME, (contentNode: ContentNodeWithPos) => {
          const parentElementName = editorView.state.doc.resolve(contentNode.pos).parent.type.name;
          return NAME_MAPPING(t)[parentElementName] || t('Lygo:editorPlaceholder');
        });

        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.paragraph.title') as string,
            description: t('Lygo:Menu.paragraph.description') as string,
            icon: NormalText,
            addMenuIcon: AddMenuText,
            addMenuItemType: addMenuItemType.basic_blocks,
            searchWords: ['text', 'paragraph', 'normal text', 'basic'],
            isText: true,
          },
        ]);

        return {};
      },
    }),
  ];
}

export default plugins;
